<template lang="pug">
  div(class="home")
    div
      urgent-trash-can(class="home__section")
      trash-can-type(class="home__section")
    div
      trash-can-amount(class="home__section")
    div
      recycle-correct-rate(class="home__section")
  </div>
</template>

<script>
import UrgentTrashCan from '@/components/home/UrgentTrashCan.vue'
import RecycleCorrectRate from '@/components/home/RecycleCorrectRate.vue'
import TrashCanType from '@/components/home/TrashCanType.vue'
import TrashCanAmount from '@/components/home/TrashCanAmount.vue'
import gsap from 'gsap'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    UrgentTrashCan,
    RecycleCorrectRate,
    TrashCanType,
    TrashCanAmount
  },
  data () {
    return {
      tl: null
    }
  },
  computed: {
    ...mapGetters({
      getIsLoading: 'getIsLoading'
    })
  },
  watch: {
    getIsLoading () {
      this.tl.play()
    }
  },
  mounted () {
    console.log('mounted')
    this.tl = gsap.timeline()
    this.tl.from('.home__section', {
      duration: 0.7,
      x: -100,
      opacity: 0,
      stagger: {
        amount: 1
      }
    })
    this.tl.pause()
  },
  activated () {
    if (!this.getIsLoading) {
      this.tl.restart()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.home {
  padding: 27px;
  > div:nth-child(n) {
    margin-bottom: 25px;
  }
  > div:nth-child(1) {
    height: 320px;
    display: flex;
  }
  > div:nth-child(2) {
    height: 360px;
  }
  > div:nth-child(3) {
    height: 360px;
  }
}
</style>
